/**
 * 微信内 uni-app H5 用 iframe 同源反代旧版 H5（/proxy-webview/）时：
 * 1. history 路由 base 必须带上前缀，否则多层路径（帖子）匹配失败白屏
 * 2. 异步 chunk 要从反代前缀加载
 * 3. 同源 iframe 与外壳共享 localStorage，禁止 localStorage.clear() 把外壳登录态清掉
 */
export const PROXY_WEBVIEW_PREFIX = '/proxy-webview'

const H5_STORAGE_KEYS = [
  'token',
  'tokenLogin',
  'expires',
  'uid',
  'ticket',
  'headimgurl',
  'nickname',
  'timestamp',
  'hasPhoneNumber',
  'points',
  'starlight',
  'phoneNumber',
  'device_id',
]

export function isProxyWebviewEmbed() {
  if (typeof window === 'undefined') return false
  const path = window.location.pathname || ''
  return path === PROXY_WEBVIEW_PREFIX || path.indexOf(PROXY_WEBVIEW_PREFIX + '/') === 0
}

export function isEmbeddedIframe() {
  if (typeof window === 'undefined') return false
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

/**
 * stats-app H5 的 web-view 是 iframe（含 /proxy-webview/）。
 * 桌面浏览器 UA 仍是 PC，这里强制走手机页，与真机 / 模拟器一致。
 */
export function shouldForceMobileLayout() {
  return isProxyWebviewEmbed() || isEmbeddedIframe()
}

export function getRouterBase() {
  if (isProxyWebviewEmbed()) return PROXY_WEBVIEW_PREFIX + '/'
  return process.env.BASE_URL || '/'
}

export function getError404Url() {
  return getRouterBase().replace(/\/?$/, '/') + 'error404'
}

function applyWebpackPublicPath() {
  if (!isProxyWebviewEmbed()) return
  try {
    // eslint-disable-next-line camelcase, no-undef
    __webpack_public_path__ = PROXY_WEBVIEW_PREFIX + '/'
  } catch (e) {
    // ignore
  }
}

function patchLocalStorageClear() {
  if (typeof window === 'undefined' || !window.localStorage) return
  if (!isProxyWebviewEmbed() && !isEmbeddedIframe()) return
  if (window.__dyxhEmbedStoragePatched) return
  window.__dyxhEmbedStoragePatched = true
  window.localStorage.clear = function clearEmbedSafe() {
    H5_STORAGE_KEYS.forEach((key) => {
      window.localStorage.removeItem(key)
    })
  }
}

applyWebpackPublicPath()
patchLocalStorageClear()
